<template>
  <div class="splash background--dark">
    <img class="temp-preloader__logo" src="/img/thishostel/splash-screen-logo@2x.png" alt="splash screen">
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss">
.splash {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  height: 100vh;
  height: -webkit-fill-available;
  transition: 0.4s 0.1s opacity;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  &.hide {
    pointer-events: none;
    opacity: 0;
  }
}
</style>
